import React, { Component } from 'react';
import '../css/ticket.css'
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';
import TicketModal from './TicketModal';
import { ValidationModal } from '../components';
import moment from "moment";
import { PayMethodCounter } from "../components/NewOrder";
import '../css/formats.css';


class RefundOfPaymentsModal extends Component {

    async componentDidMount() {
        await this.SumOfAmounts();
    }

    findInName(word, name) {
        let response = name.toUpperCase().includes(word)
        return (response)
    }

    SumOfAmounts = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel } = this.props;
        let totalAmount = 0;
        for (const payAdded of newOrderModel.PaymentsToReturn) {

            if (Number(payAdded.TypeMethod) !== 117) {
                totalAmount = totalAmount + Number(payAdded.Amount);
            }

        }

        newOrderModel.TotalRecibido = totalAmount;
        newOrderModel.TotalRestante = totalAmount ? (totalAmount - newOrderModel.Total) > 0 ? totalAmount - newOrderModel.Total : 0 : 0;

        newOrderModel.RemainingAmount = parseFloat(Number(newOrderModel.Total) - Number(totalAmount)).toFixed(2);
        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount)

        // newOrderModel.TotalRestante = totalAmount < newOrderModel.Total ?  newOrderModel.Total - totalAmount : 0;
        await RefreshOrder(newOrderModel);
        await this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        const { RefreshPaymentSaleModel } = this.props;
        RefreshPaymentSaleModel(PaymentSaleModel);
    }

    //#region ######### CHANGE PAYMENT GENERAL FIELDS ############################################################ 
    ChangeAmount = (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "warning", message: `Agregue un valor valido` });
            return
        }
        PaymentSaleModel.Amount = Number(value);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ChangeTypePayMethod = (payMethod, flag, auxRelatedPaymethod) => {
        const { PaymentSaleModel, newOrderModel } = this.props;

        PaymentSaleModel.idPMBO = payMethod.idPMBO;
        PaymentSaleModel.PM_Name = payMethod.name;
        PaymentSaleModel.PM_Code = payMethod.idAPMBO;
        PaymentSaleModel.TypeMethod = payMethod.type;
        PaymentSaleModel.AcctCode = payMethod.AcctCode;
        // CHEQUE  
        PaymentSaleModel.PaycheckNum = flag && payMethod.type === '1' ? auxRelatedPaymethod.paycheckNum : '';
        PaymentSaleModel.DatePaycheck = moment(new Date()).format("YYYY-MM-DD");
        PaymentSaleModel.BankCode = flag && payMethod.type === '1' ? auxRelatedPaymethod.bankCode : '';
        PaymentSaleModel.BankName = flag && payMethod.type === '1' ? auxRelatedPaymethod.bankName : '';

        // TARJETAS
        PaymentSaleModel.CreditCard = flag && payMethod.type === '2' ? Number(auxRelatedPaymethod.creditCard) : '';
        PaymentSaleModel.CardNum = flag && payMethod.type === '2' ? auxRelatedPaymethod.cardNum : '';
        PaymentSaleModel.VoucherNum = flag && payMethod.type === '2' ? auxRelatedPaymethod.authorizationNum : '';
        PaymentSaleModel.Indentification = flag && payMethod.type === '2' ? auxRelatedPaymethod.indentification : '';
        PaymentSaleModel.PhoneNum = flag && payMethod.type === '2' ? auxRelatedPaymethod.phoneNum : '';
        PaymentSaleModel.CardValid = flag && payMethod.type === '2' ? auxRelatedPaymethod.cardValidUntil : '';

        // TRANSFERENCIA
        PaymentSaleModel.TransferNum = flag && payMethod.type === '3' ? auxRelatedPaymethod.transferNum : '';
        PaymentSaleModel.PayAccountNum = flag && payMethod.type === '3' ? auxRelatedPaymethod.payAccountNum : '';

        PaymentSaleModel.ReturnFolio = '';
        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount);

        PaymentSaleModel.auxObjDP = {};
        PaymentSaleModel.DocEntryDP = '';
        PaymentSaleModel.AmountDP = 0;
        PaymentSaleModel.NumAtCardDP = '';

        PaymentSaleModel.AvailableAmount = 0;

        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }
    //#endregion

    //#region ######### ADD OR REMOVE METHOD ############################################################ 
    addingPaymentSale = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel, showAlert, AddPay } = this.props;
        let auxPaymentSaleModel = new PayMethodCounter();

        if (PaymentSaleModel.Amount === '' || Number(PaymentSaleModel.Amount) === 0) {
            showAlert({ type: "warning", message: `No es posible dejar el monto vació` });
            return
        }
        if (PaymentSaleModel.TypeMethod === '') {
            showAlert({ type: "warning", message: `No has seleccionado un método de pago` });
            return
        }

        let newArray = newOrderModel.PaymentsToReturn;
        newArray.push(PaymentSaleModel);
        newOrderModel.PaymentsToReturn = newArray;
        await RefreshOrder(newOrderModel);

        this.RefreshPaymentSaleModel(auxPaymentSaleModel);
        if (Number(PaymentSaleModel.TypeMethod) === 117) {
            await this.AffectSubTotal(PaymentSaleModel.AmountDP);
        }
        this.SumOfAmounts();
        AddPay();
    }

    RemovePaymentSale = async (index) => {
        const { RefreshOrder, newOrderModel } = this.props;
        let newArray = newOrderModel.PaymentsToReturn;
        newArray.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        newOrderModel.PaymentsToReturn = newArray;
        await RefreshOrder(newOrderModel);
        this.SumOfAmounts();
    }
    //#endregion

    render() {
        const {
            AvailablePayments, PaymentSaleModel, AddPay,
            newOrderModel, CancelReturnPayment, addingPay,
            Devolver, RelatedPayMethodsByDoc, user,
            action, SalesTools, ItsCreditInvoice
        } = this.props;
        AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
        let retunType = 'Devolver';
        let showPaymentForms = true;

        if (RelatedPayMethodsByDoc && RelatedPayMethodsByDoc.length > 0) {
            if (Number(newOrderModel.ObjType) === 13) {
                retunType = newOrderModel.PaymentsToReturn.length === 0 ? (ItsCreditInvoice && Number(newOrderModel.AbonadoTotal) === 0) ? 'Generar' : 'A cuenta' : 'Devolver forma de pago';
            }else {
                retunType = newOrderModel.PaymentsToReturn.length === 0 ? 'Como forma de pago' : 'Devolver forma de pago';
            }
        } else {
            retunType = 'Devolver';
            showPaymentForms = false;
        }

        return (
            <>
                <div className="modal fade" id="refundOfPaymentsModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" aria-labelledby="refundOfPaymentsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <form>
                                    <div className="mb-2">
                                        <h3 className="title">Total {action && action === 'cancel' ? 'cancelación' : 'devolución'}: </h3>
                                        <div className="card row " style={{ fontSize: "xxx-large", background: "#00800012", border: "none", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                            <div className=" text-center col-12 pb-2" >
                                                <span style={{ color: "green" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Total)}</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="">
                                        <h3 className="title">Forma de {action && action === 'cancel' ? 'cancelación' : 'devolución'} pago:</h3>
                                        {addingPay !== true && showPaymentForms &&
                                            <div className="row mt-4 pr-2">
                                                <div className='pl-4 col-12'>
                                                    <button type="button" className="form-control btn btn-primary" onClick={AddPay}>
                                                        {/* <i className="fa fa-plus-circle mr-2" aria-hidden="true"/> */}
                                                        Agregar pago
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {addingPay === true && /*newOrderModel.PaymentsToReturn.length > 0 &&*/
                                            <div className="row mt-4 pr-2">
                                                <div className='pl-4 col-12'>
                                                    <button type="button" className="form-control btn btn-secondary" onClick={AddPay}>
                                                        {/* <i className="fa fa-plus-circle mr-2" aria-hidden="true"/> */}
                                                        Lista de pagos
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {addingPay === true &&
                                            <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                <div className='pl-4 col-12'>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        placeholder="Buscar método de pago: "
                                                        id="paymentSearch"
                                                        onKeyUp={() => this.DoSearch("payments", "paymentSearch")}
                                                    />
                                                    <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                        <table id="payments">
                                                            <tbody>
                                                                {AvailablePayments && AvailablePayments.length > 0 &&
                                                                    AvailablePayments.map((payMethod, index) => {
                                                                        let flag = ItsCreditInvoice ? true : false;
                                                                        let auxRelatedPaymethod = {};


                                                                        if (RelatedPayMethodsByDoc && RelatedPayMethodsByDoc.length > 0 && !ItsCreditInvoice) {
                                                                            for (let i = 0; i < RelatedPayMethodsByDoc.length; i++) {
                                                                                const payedMethod = RelatedPayMethodsByDoc[i];
                                                                                if (payedMethod.typeMethod === payMethod.type && payedMethod.idPMBO === payMethod.idPMBO) {
                                                                                    flag = true;
                                                                                    auxRelatedPaymethod = payedMethod;
                                                                                }
                                                                            }
                                                                        }
                                                                        
                                                                        return (
                                                                            <tr key={index} className={`m-1 ${flag ? 'selectedPayMethod' : ''}`} style={{ boxShadow: "none", display: flag ? '' : 'none' }}>
                                                                                <td>
                                                                                    <input
                                                                                        className='ml-2 mr-2'
                                                                                        type="radio"
                                                                                        style={{ width: "50px" }}
                                                                                        checked={PaymentSaleModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                                        onChange={() => this.ChangeTypePayMethod(payMethod, flag, auxRelatedPaymethod)}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-1 text-center'>
                                                                                    <i className={
                                                                                        this.findInName("EFECTIVO", payMethod.name) ? "fa fa-money" :
                                                                                            // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                            this.findInName("CHEQUE", payMethod.name) ? "fa fa-keyboard-o" :
                                                                                                this.findInName("TRANS", payMethod.name) ? "fa fa-exchange" :
                                                                                                    this.findInName("CRÉDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                        ""
                                                                                    }
                                                                                        aria-hidden="true"
                                                                                        style={{ margin: "1rem" }}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-1 text-left' style={{ fontSize: "15px" }}> {payMethod.name.toUpperCase() || ''}</td>

                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {/* IMPORTE */}
                                        {addingPay === true &&
                                            <div className="row mt-3 pr-2" style={{ fontSize: "larger" }}>
                                                <div className="col-3 pl-4">
                                                    <label className="form-label mt-1">Importe: </label>
                                                </div>
                                                <div className="col-7 pl-4">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min={0}
                                                        value={PaymentSaleModel.Amount || ''}
                                                        placeholder={PaymentSaleModel.Amount || 0}
                                                        onChange={(event) => this.ChangeAmount(event.nativeEvent.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.addingPaymentSale();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-1 pl-4">
                                                    <button
                                                        type="button"
                                                        onClick={() => this.addingPaymentSale()}
                                                        className="btn btn-outline-success">
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />

                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        
                                        {/* MÉTODOS DE PAGO AGREGADOS */}
                                        {addingPay !== true &&
                                            <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                <div className='pl-4 col-12'>
                                                    <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "300px", minHeight: "200px", overflowY: "scroll" }}>
                                                        <table className="table-striped table-hover" id="payments">
                                                            <tbody>
                                                                {newOrderModel && newOrderModel.PaymentsToReturn.length > 0 &&
                                                                    newOrderModel.PaymentsToReturn.map((payMethod, index) => {
                                                                        return (
                                                                            <tr key={index} style={{ boxShadow: "none" }}>

                                                                                <td className='text-center'>
                                                                                    <i className={
                                                                                        this.findInName("EFECTIVO", payMethod.PM_Name) ? "fa fa-money" :
                                                                                            // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                            this.findInName("CHEQUE", payMethod.PM_Name) ? "fa fa-keyboard-o" :
                                                                                                this.findInName("TRANS", payMethod.PM_Name) ? "fa fa-exchange" :
                                                                                                    this.findInName("CRÉDITO", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                        ""
                                                                                    }
                                                                                        aria-hidden="true"
                                                                                        style={{ margin: "1rem" }}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-1 col-sm-auto text-left' style={{ fontSize: 'initial' }}>
                                                                                    {
                                                                                        this.findInName("EFECTIVO", payMethod.PM_Name) ? "EFECTIVO" :
                                                                                            // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                            this.findInName("CHEQUE", payMethod.PM_Name) ? "CHEQUE" :
                                                                                                this.findInName("TRANS", payMethod.PM_Name) ? "TRANSFERENCIA" :
                                                                                                    this.findInName("CRÉDITO", payMethod.PM_Name) ? "TARJETA" :
                                                                                                        payMethod.PM_Name
                                                                                    }
                                                                                </td>
                                                                                <td className='p-1 col-sm-auto'>{CURRENCY + ' ' + FORMAT_NUMBER.new(payMethod.Amount)}</td>
                                                                                <td className='p-1 col-sm-auto'>

                                                                                    <i className="fa fa-trash-o" style={{ color: "#dc3545", margin: "1rem" }} onClick={() => this.RemovePaymentSale(index)} />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="card-details">
                                        <h3 className="title mt-4">Cambio:</h3>
                                        <div className="card row" style={{ fontSize: "xxx-large", border: "none", background: "#0499f212", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                            <div className=" text-center col-12 pb-2" >
                                                <span style={{ color: "#0458b2", fontWeight: "bold" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.TotalRestante)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-2 mr-4" data-dismiss="modal" onClick={CancelReturnPayment}>Cancelar</button>
                                        <button className="btn-lg btn-primary d-block w-100 col-8" type="submit" data-toggle="modal" onClick={action && action === 'cancel' ? () => SalesTools.CloseDocument() : () => Devolver(showPaymentForms)}>{retunType}</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationModal
                    idValidation="validationModal"
                    message="¿Esta seguro que quiere continuar?"
                    eventOnclick={()=> {}}
                />

                <TicketModal
                    CloseBillModal={"CloseBillModal"}
                    newOrderModel={"newOrderModel"}
                    Print={"Print"}
                    _user={user} />
            </>
        );
    }
}

export default RefundOfPaymentsModal;